import React, {Component} from 'react'
import NoMatchComponent from '../../components/NoMatch.jsx'
import {Route, Switch} from 'react-router-dom'
import SessionsCont from '../../components/Admin/SessionsCont'
import RulesCont from '../../components/Admin/RulesCont'

export default function AdminRouter(props) {
  const url = props.match.url

  return (
    <Switch>
      <Route
        path={`${url}/sessions`}
        name="sessions"
        component={SessionsCont}
      />
      <Route path={`${url}/rules`} name="sessions" component={RulesCont} />
      <Route component={NoMatchComponent} />
    </Switch>
  )
}
